import { Flex, Icon, Text, VStack, useCallbackRef } from '@chakra-ui/react';
import { FiCheck } from '@react-icons/all-files/fi/FiCheck';
import { ReactNode, useEffect } from 'react';

const SUCCESS_CLOSE_DELAY_MS = 1200;

type TaskSuccessStateProps = {
  title: string;
  onClose: () => void;
  children?: ReactNode;
};

const TaskSuccessState = ({ title, onClose, children }: TaskSuccessStateProps) => {
  // Identity-stable so an unstable onClose doesn't restart the timer.
  const stableOnClose = useCallbackRef(onClose);
  useEffect(() => {
    const timeout = setTimeout(stableOnClose, SUCCESS_CLOSE_DELAY_MS);
    return () => clearTimeout(timeout);
  }, [stableOnClose]);

  return (
    <VStack spacing={4} pb={6}>
      <Flex
        w="52px"
        h="52px"
        borderRadius="full"
        align="center"
        justify="center"
        bg="leaseEndGreen"
        color="white"
      >
        <Icon as={FiCheck} boxSize="26px" />
      </Flex>
      <Text fontWeight={700} color="leaseEndBlue">
        {title}
      </Text>
      {children}
    </VStack>
  );
};

export default TaskSuccessState;
